// tslint:disable-next-line: max-line-length
export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_PATTERN = /^[1-9][0-9]*$/;
export const NUMBER_PATTERN = /^\d+$/;
export const NUMERIC_PATTERN = /^[0-9]*$/;
export const ALPHANUMERIC_PATTERN = /^[a-zA-Z0-9]*$/;
export const ALPHABETIC_PATTERN = /^[A-Za-záéíóúüÁÉÍÓÚÜñÑ ]*$/;
export const ADDRESS_PATTERN = /^[A-Za-záéíóúüÁÉÍÓÚÜñÑ0-9.,\-\/ ]*$/;
export const FILE_REG_RENAME = /\W/g;
